<template>
  <div>
    <div class="top_tit">
      <div class="line"></div>
      <p>{{ operation.Name }}</p>
    </div>
    <div class="bottom_content">
      <ul v-if="operation.Subjects.length > 0">
        <div
          v-for="(d, i) in operation.Subjects"
          :key="d.DeliveryId"
          class="bottom_content_box"
        >
          <p style="padding-top: 10px">
            作业{{ i + 1 }} ：
            <span v-html="hhText(d.DeliveryName)"></span>
          </p>
          <div v-if="d.IsSubmitted">
            <div
              style="
                color: #84848a;
                font-size: 15px;
                margin-top: 10px;
                word-break: break-all;
              "
              v-html="hhText(d.Content)"
            ></div>
            <li
              v-for="(item2, key2) in d.Image"
              :key="key2 + 'i'"
              @click="downloadFile(item2.DeliveryUrl || item2.deliveryUrl)"
            >
              <img :src="api.FileHost + item2.DeliveryUrl" />
            </li>
            <li
              v-for="(item2, key2) in d.Video"
              :key="key2 + 'i'"
              @click="downloadFile(item2.DeliveryUrl || item2.deliveryUrl)"
            >
              <div class="bottom_content_list">
                <img
                  height="100"
                  src="../../../assets/images/shipin.png"
                  width="300"
                />
                <p>{{ item2.DeliveryName }}</p>
              </div>
              <img
                alt=""
                class="arrowIcon"
                src="../../../assets/images/arrowright.svg"
              />
            </li>
            <li
              v-for="(item2, key2) in d.Audio"
              :key="key2 + 'i'"
              @click="downloadFile(item2.DeliveryUrl || item2.deliveryUrl)"
            >
              <div class="bottom_content_list">
                <img
                  height="100"
                  src="../../../assets/images/yinye.png"
                  width="300"
                />
                <p>{{ item2.DeliveryName }}</p>
              </div>
              <img
                alt=""
                class="arrowIcon"
                src="../../../assets/images/arrowright.svg"
              />
            </li>
            <li
              v-for="(item2, key2) in d.File"
              :key="key2 + 'i'"
              @click="downloadFile(item2.DeliveryUrl || item2.deliveryUrl)"
            >
              <div class="bottom_content_list">
                <div class="icon_box">
                  <span v-if="item2.DeliveryName">
                    {{ getFileName(item2.DeliveryName) }}
                  </span>
                </div>
                <p>{{ item2.DeliveryName }}</p>
              </div>
              <img
                alt=""
                class="arrowIcon"
                src="../../../assets/images/arrowright.svg"
              />
            </li>
          </div>
          <p v-if="d.Commented" class="dsdp_box">
            <span>导师点评：</span>
            <span v-html="hhText(d.Comment)"></span>
          </p>
          <div
            v-if="operation.Subjects.length > 0 && state == '10'"
            class="wwc_box"
          >
            <p v-if="!d.IsSubmitted">未完成</p>
            <p v-else></p>

            <div v-if="d.IsSubmitted" class="btn" @click="submitWork(d, i)">
              修改作业
              <van-icon color="#b57e48 " name="arrow" size="15px" />
            </div>
            <div v-else class="btn" @click="submitWork(d, i)">
              上传作业
              <van-icon color="#b57e48 " name="arrow" size="15px" />
            </div>
          </div>
        </div>
      </ul>
      <van-empty v-else description="暂无课程作业" image-size="40" />
    </div>
  </div>

  <!-- 表单 -->
  <!-- <van-overlay v-if="show" :lock-scroll="true" :show="show" z-index="999"> -->
  <van-popup
    v-if="show"
    v-model:show="show"
    position="bottom"
    :style="{ height: '100%', width: '100% ' }"
  >
    <div class="wrapper" @click.stop>
      <WorkAdd :homework="homework" @cenal="cenal" @cenalTj="cenalTj" />
    </div>
  </van-popup>
  <!-- </van-overlay> -->
</template>

<script>
  import { Dialog } from 'vant'
  import { hhText } from '@/utils/index'
  import api from '@/api'
  import WorkAdd from './Workadd.vue'
  import { copyText } from '../../../utils/index'
  export default {
    components: {
      WorkAdd,
    },
    props: {
      // eslint-disable-next-line vue/require-default-prop
      operation: {
        type: Object,
      },
      // eslint-disable-next-line vue/require-default-prop
      state: {
        type: Number,
      },
      // eslint-disable-next-line vue/require-default-prop
      nodestatus: {
        type: Number,
      },
    },
    data() {
      return {
        url: '',
        hhText,
        api,
        show: false,
        // DeliveryType: null,
        // id: '',
        // ind: '',
        // Content: '',
        // DeliveryFiles: [],
        homework: {},
      }
    },
    mounted() {},
    methods: {
      downloadFile(url, DeliveryType) {
        const u = navigator.userAgent
        const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
        if (url.indexOf('.') === -1) {
          Dialog.alert({
            title: '暂不支持下载',
            confirmButtonText: '确定',
          }).then(() => {})
          return
        }
        if (isiOS) {
          if (
            DeliveryType === 10 ||
            DeliveryType === 20 ||
            DeliveryType === 30
          ) {
            if (url.includes('.amr')) {
              Dialog.alert({
                title: '请复制链接至浏览器下载',
                message: api.FileHost + url,
                confirmButtonText: '复制',
              }).then(() => {
                copyText(api.FileHost + url)
              })
            } else {
              window.open(api.FileHost + url)
            }
          } else {
            Dialog.alert({
              title: '请复制链接至浏览器下载',
              message: api.FileHost + url,
              confirmButtonText: '复制',
            }).then(() => {
              copyText(api.FileHost + url)
            })
          }
        } else {
          Dialog.alert({
            title: '请复制链接至浏览器下载',
            message: api.FileHost + url,
            confirmButtonText: '复制',
          }).then(() => {
            copyText(api.FileHost + url)
          })
        }
      },
      //禁止滚动
      stop() {
        var mo = function (e) {
          e.preventDefault()
        }
        document.body.style.overflow = 'hidden'
        document.addEventListener('touchmove', mo, false) //禁止页面滑动
      },

      //取消滑动限制
      move() {
        var mo = function (e) {
          e.preventDefault()
        }
        document.body.style.overflow = '' //出现滚动条
        document.removeEventListener('touchmove', mo, false)
      },
      getFileName(str) {
        return str.split('.')[str.split('.').length - 1]
      },
      submitWork(data, i) {
        // this.$router.push({
        //   name: 'workAdd',
        //   params: {
        //     type: DeliveryType,
        //     id: id,
        //     content: Content,
        //     DeliveryFiles: JSON.stringify(DeliveryFiles),
        //   },
        // })
        // this.DeliveryType = DeliveryType
        // this.id = id
        // this.Content = Content
        // this.DeliveryFiles = DeliveryFiles
        this.homework = data
        this.show = true
        this.ind = i
        this.stop()
      },
      cenal() {
        this.show = false
        this.move()
      },
      cenalTj(val) {
        console.log('val', val)
        this.show = false
        this.move()
        this.operation.Subjects[this.ind].Content = val.content
        this.operation.Subjects[this.ind].DeliveryFiles = val.deliveryFiles
        this.operation.Subjects[this.ind].Video = val.Video
        this.operation.Subjects[this.ind].Audio = val.Audio
        this.operation.Subjects[this.ind].Image = val.Image
        this.operation.Subjects[this.ind].File = val.File
        this.operation.Subjects[this.ind].IsSubmitted = true
      },
    },
  }
</script>

<style lang="scss" scoped>
  .bottom_content {
    min-height: 90px !important;
    .dsdp_box {
      background-color: #eee;
      padding: 6px 10px;
      margin-top: 10px;
      span {
        font-weight: bold;
      }
    }
    ul {
      .bottom_content_box {
        border-bottom: 1px solid #e4e5ea;
        margin-bottom: 10px;
      }
      .bottom_content_box:last-child {
        border-bottom: none;
        margin-bottom: 0;
      }
      .wwc_box {
        width: 100%;
        height: 50px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        p {
          font-size: 15px;
          font-family: ' Source Han Sans CN';
          font-weight: 400;
          color: #84848a;
        }
      }
      p {
        font-size: 12px;
        color: #333;
      }
      .btn {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #b57e48;
      }
      li {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 14px;
        border-bottom: 1px solid #e4e5ea;
        margin-top: 16px;
        .arrowIcon {
          width: 24px;
        }
        .bottom_content_list {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          width: 92%;
          .icon_box {
            background-color: #454976;
            width: 28px;
            height: 28px;
            border-radius: 4px;
            display: flex;
            flex-direction: row;
            font-size: 12px;
            color: #fff;
            justify-content: center;
            align-items: center;
          }
          img {
            width: 28px;
            height: 28px;
          }
          p {
            font-size: 15px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #84848a;
            margin-left: 14px;
            width: 87%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      li:last-child {
        border-bottom: none;
      }
    }
  }
</style>
